import React from "react";
import { addWidget, removeWidget, reorderWidget } from "../db/action";
import { selectWidgets } from "../db/select";
import { db } from "../db/state";
import { useSelector } from "../lib/db/react";
import { widgetConfigs } from "../plugins";
import SettingWidget from "./SettingWidget";

const SettingWidgets: React.FC = () => {
  const widgets = useSelector(db, selectWidgets);

  return (
    <div>
      <label>
        <select
          value=""
          onChange={(event) => addWidget(event.target.value)}
          className="primary"
        >
          <option disabled value="">
            Add a new widget
          </option>
          {widgetConfigs.map((plugin) => (
            <option key={plugin.key} value={plugin.key}>
              {plugin.name}
            </option>
          ))}
        </select>
      </label>

      {widgets.map((widget, index) => (
        <SettingWidget
          key={widget.id}
          plugin={widget}
          onMoveUp={
            index > 0 ? () => reorderWidget(index, index - 1) : undefined
          }
          onMoveDown={
            index < widgets.length - 1
              ? () => reorderWidget(index, index + 1)
              : undefined
          }
          onRemove={() => removeWidget(widget.id)}
        />
      ))}
    </div>
  );
};

export default SettingWidgets;
